import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from './body/content/content.component';
import { MaintenancePageComponent } from './maintenance/maintenance-page/maintenance-page.component';
import { maintenanceGuard } from './maintenance/services/maintenance.guard';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
    {
        path: 'external/:projectId',
        pathMatch: 'full',
        canActivate: [AuthGuardService, maintenanceGuard],
        component: ContentComponent,
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [AuthGuardService, maintenanceGuard],
        component: ContentComponent,
    },
    {
        path: 'maintenance',
        component: MaintenancePageComponent,
        pathMatch: 'full',
    },
    { path: '**', redirectTo: '', canActivate: [maintenanceGuard] },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
